<div [class]="'c-box' + ' ' + classes.join(' ')">
  <ng-content></ng-content>
</div>
